"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAID_COUPON_AMOUNT_KEY = exports.PAID_COUPON_KEY = void 0;
exports.PAID_COUPON_KEY = 'paid-coupon';
exports.PAID_COUPON_AMOUNT_KEY = 'paid-coupon-amount';
//# sourceMappingURL=constants.js.map